import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavLibraryActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.82 1.25H3C2.04 1.25 1.25 2.04 1.25 3V9.82C1.25 10.51 1.81 11.07 2.5 11.07H9.82C10.51 11.07 11.07 10.51 11.07 9.82V2.5C11.07 1.81 10.51 1.25 9.82 1.25Z"
        fill={color}
      />
      <path
        d="M21 1.25H14.18C13.49 1.25 12.93 1.81 12.93 2.5V9.82C12.93 10.51 13.49 11.07 14.18 11.07H21.5C22.19 11.07 22.75 10.51 22.75 9.82V3C22.75 2.04 21.96 1.25 21 1.25Z"
        fill={color}
      />
      <path
        d="M9.82 12.93H2.5C1.81 12.93 1.25 13.49 1.25 14.18V21C1.25 21.96 2.04 22.75 3 22.75H9.82C10.51 22.75 11.07 22.19 11.07 21.5V14.18C11.07 13.49 10.51 12.93 9.82 12.93Z"
        fill={color}
      />
      <path
        d="M21.5 12.93H14.18C13.49 12.93 12.93 13.49 12.93 14.18V21.5C12.93 22.19 13.49 22.75 14.18 22.75H21C21.96 22.75 22.75 21.96 22.75 21V14.18C22.75 13.49 22.19 12.93 21.5 12.93ZM21.25 21C21.25 21.14 21.14 21.25 21 21.25H14.43V14.43H21.25V21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavLibraryActiveIcon.displayName = 'NavLibraryActiveIcon';
